import React, { useContext } from 'react';
import styled from 'styled-components';
import Context from '../Context';
import Videos from './Videos';
import End from './End';
import Start from './Start';
import { displayFlex, heightWidth100 } from '../constants';

const HomeScreen = styled.div`
  ${displayFlex}
  ${heightWidth100}
`;

export default function Home() {
  const { narrative, clips } = useContext(Context);
  const start = narrative.length < 1;
  const end = clips === narrative;

  return (
    <HomeScreen className="home-screen">
      {start && <Start />}
      {end && <End />}
      <Videos />
    </HomeScreen>
  );
}
